/* eslint-disable import/prefer-default-export */
export const NOTIFICATION_UPDATE_INTERVAL = Number(
    process.env.NOTIFICATION_UPDATE_INTERVAL,
);
